import { render, staticRenderFns } from "./purchaseStockIn.vue?vue&type=template&id=77e84f4c&scoped=true"
import script from "./purchaseStockIn.vue?vue&type=script&lang=js"
export * from "./purchaseStockIn.vue?vue&type=script&lang=js"
import style0 from "./purchaseStockIn.vue?vue&type=style&index=0&id=77e84f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e84f4c",
  null
  
)

export default component.exports